
export default function PrivacyPolicyPage() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white shadow-md">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <a href="/" className="flex items-center gap-3">
            <img 
              src="https://static.readdy.ai/image/a5e7a8d75a8d5f4ed40cacf34a3df597/11df6f839158c987a838fe6484b0b0b8.jpeg" 
              alt="Vortex Digital Assets" 
              className="h-10 w-10 object-contain"
            />
            <span className="text-xl font-semibold text-gray-900">
              Vortex Digital Assets
            </span>
          </a>
          
          <a 
            href="/"
            className="text-sm font-medium text-gray-600 hover:text-teal-600 transition-colors"
          >
            Back to Home
          </a>
        </div>
      </nav>

      {/* Content */}
      <section className="py-24 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6">
          <div className="mb-8">
            <h1 className="text-5xl font-bold text-gray-900 mb-4">Privacy Policy</h1>
            <p className="text-sm text-gray-500">Last updated: January 2026</p>
          </div>
          
          <div className="bg-white rounded-2xl p-12 shadow-sm border border-gray-200">
            <div className="prose prose-lg max-w-none">
              <p className="text-lg text-gray-700 leading-relaxed">
                We take your privacy seriously. Vortex Digital Asset uses <strong>industry-standard SSL encryption</strong> to protect all transactional data. We do not store full credit card details on our servers, and we never sell client information to third-party marketing firms.
              </p>
              
              <p className="text-lg text-gray-700 leading-relaxed mt-6">
                Your data is used strictly for order fulfillment and account security.
              </p>
              
              <div className="mt-8 grid md:grid-cols-2 gap-6">
                <div className="bg-teal-50 p-6 rounded-lg border border-teal-200">
                  <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center mb-4">
                    <i className="ri-shield-check-line text-2xl text-white"></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Data Security</h3>
                  <p className="text-sm text-gray-700">
                    All transactions are protected with bank-level SSL encryption and secure payment processing.
                  </p>
                </div>
                
                <div className="bg-slate-50 p-6 rounded-lg border border-slate-200">
                  <div className="w-12 h-12 bg-slate-800 rounded-full flex items-center justify-center mb-4">
                    <i className="ri-lock-line text-2xl text-white"></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">No Data Selling</h3>
                  <p className="text-sm text-gray-700">
                    We never share or sell your information to third-party marketing companies.
                  </p>
                </div>
              </div>
              
              <div className="mt-8 bg-teal-50 border-l-4 border-teal-600 p-6 rounded-r-lg">
                <h3 className="text-xl font-bold text-gray-900 mb-2">Privacy Questions?</h3>
                <p className="text-base text-gray-700 mb-4">
                  Contact our privacy team for any questions about how we handle your data.
                </p>
                <a 
                  href="mailto:sales.vortexdigital@gmail.com" 
                  className="flex items-center gap-2 text-teal-600 hover:text-teal-700 font-medium"
                >
                  <i className="ri-mail-line"></i>
                  sales.vortexdigital@gmail.com
                </a>
              </div>
            </div>
          </div>
          
          <div className="mt-8 text-center">
            <button 
              onClick={scrollToTop}
              className="text-teal-600 hover:text-teal-700 font-medium flex items-center gap-2 mx-auto"
            >
              <i className="ri-arrow-up-line"></i>
              Back to Top
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-800 text-white py-12">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400">
              © 2026 Vortex Digital Assets. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a href="/terms-of-service" className="text-sm text-gray-400 hover:text-teal-400 transition-colors">
                Terms of Service
              </a>
              <a href="/refund-policy" className="text-sm text-gray-400 hover:text-teal-400 transition-colors">
                Refund Policy
              </a>
              <a href="/privacy-policy" className="text-sm text-gray-400 hover:text-teal-400 transition-colors">
                Privacy Policy
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
